export default __webpack_public_path__ + "static/media/18.24f44618.png";